import React from 'react';
import { withPrefix, Link } from 'gatsby';
import ReactMarkdown from 'react-markdown';

let lastScrollY = 0;
let videoheight = 0;
let ticking = false;

export default class Templatesets extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            locale: props.locale,
            data: props.templatesets,
        };
        this.handleScroll = this.handleScroll.bind(this);
    }

    createThumbnails = () => {
        let thumbnails = [];
        let maxThumbnailCount = 20; 
        let key = 0;

        for (let i = 1; i <= maxThumbnailCount; i++) {
            thumbnails.push(<div key={key++} className="thumbnail"><img src={withPrefix(`/img/templatesets/templatesets-${i}.jpg`)} alt="thumbnail" /></div>)
            if(i == 20){
                i = 1;
                maxThumbnailCount = 5;
            }
        }

        return thumbnails
    }

    componentDidMount() {
        this.handleScroll();
        window.addEventListener('scroll', this.handleScroll);
    };
    
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    };
    
    video = React.createRef();

    handleScroll(event) {
        
        if(this.video.current && window.innerWidth > "980"){
            videoheight = this.video.current.getBoundingClientRect().height / 3;
            lastScrollY = ((window.innerHeight - window.scrollY)/ - 3) + window.innerHeight/8;
            if(lastScrollY > 0) lastScrollY = 0;
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    this.video.current.style.transform = `translateY(${lastScrollY}px)`;
                    ticking = false;
                });
                ticking = true;
            }
        }
    };

    render() {
        const locale = this.state.locale;
        const data = this.state.data
        return (
            <section className="templatesets">
                <div className="container">
                    <div className="columns">
                        <div className="column">
                            <div className="headliner starfield t3">
                                <ReactMarkdown source={ data.templatesetsHeadline } />
                                <p>
                                    { data.templatesetsHeadlineSubtext }
                                </p>
                            </div>
                        </div>  
                        <div className="column is-three-fifths">
                            <div className="card " ref={this.video}>
                                <div className="card-image">
                                    <figure className="image is-16by9">
                                    <video width="1280" height="720" autoPlay="autoplay" loop="loop" muted="muted" poster={withPrefix('/video/templateset.jpg')}>
                                        <source src={withPrefix('/video/templateset.webm')} type="video/webm" />
                                        <source src={withPrefix('/video/templateset.mp4')} type="video/mp4"/>
                                        <source src={withPrefix('/video/templateset.ogv')} type="video/ogv" />
                                        <p>Your browser does not support the video tag.</p>
                                    </video>                                    
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  

                <div className="thumbnail-slider">
                    <div className="thumbnails">
                        {this.createThumbnails()}
                    </div>
                </div>
            </section>
        );
  }
};

